import { IconAppleShare } from '@monofe/ui-common/icon';
import type { CSSProperties, ReactNode } from 'react';
import AppIconView from './AppIconView';
import type { IInstallBannerView } from './InstallBannerView.interface';
import { classNameForElement, StyleElem, styleForElement } from './InstallBannerView.style';
import { default as HeadingView, default as SubHeadingView } from './SubHeadingView';

interface StyleProps {
    style?: CSSProperties;
    className?: string;
}

function FooterView(props: StyleProps): JSX.Element {
    return (
        <p className={props.className} style={props.style}>
            Just tap
            <IconAppleShare
                style={{
                    color: '#4A8CF6',
                    height: '50%',
                    paddingLeft: '2%',
                    paddingRight: '2%',
                    paddingBottom: '2%',
                }}
            />
            &amp; 'add to home screen'
        </p>
    );
}

function InnerDiv(props: { children?: ReactNode } & StyleProps): JSX.Element {
    return (
        <div
            className={props.className ?? ''}
            style={{
                width: '100%',
                height: '100%',
                padding: '5%',
                paddingLeft: '10%',
                paddingRight: '10%',
                textAlign: 'center',
                boxSizing: 'border-box',
                ...props.style,
            }}
        >
            {props.children}
        </div>
    );
}

function InstallBannerView(props: IInstallBannerView): JSX.Element {
    const style = (element: StyleElem) => styleForElement(element, props);
    const className = (element: StyleElem) => classNameForElement(element, props);

    return (
        <div
            className={`${props.className ?? ''} ${className(StyleElem.Container)}`}
            style={{ ...props.style, ...style(StyleElem.Container) }}
        >
            <InnerDiv style={{ height: '40%' }}>
                <AppIconView url={props.appIconUrl} />
            </InnerDiv>
            <HeadingView
                style={style(StyleElem.Heading)}
                className={className(StyleElem.Heading)}
                text={props.heading.text}
            />
            <SubHeadingView
                style={style(StyleElem.SubHeading)}
                className={className(StyleElem.SubHeading)}
                text={props.subheading.text}
            />
            <FooterView style={style(StyleElem.Footer)} className={className(StyleElem.Footer)} />
            {props.children}
        </div>
    );
}

export default InstallBannerView;
